<template>
  <div style="padding: 0 15px;">
    <el-form ref="channelPostForm" :model="postForm" label-position="left" label-width="105px">
      <el-form-item label="选择校区">
        <Select key="6" :selected.sync="postForm.schoolId" :data="schoolList" placeholder="请选择" />
      </el-form-item>
      <el-button type="primary" @click="createData"> 保存 </el-button>
    </el-form>
  </div>
</template>

<script>

import Select from '@/components/Select'
import Tool from '@/assets/js/tool.js'

const defaultPostForm = {
  schoolId: '',
  shop_id: '',
  schoolName: ''
}

export default {
  name: 'DeviceStoreMange',
  components: {
    Select
  },
  props: {
    shopId: {
      type: [String, Number],
      required: false,
      default: ''
    },
    schoolId: {
      type: [String, Number],
      required: false,
      default: ''
    }
  },
  data() {
    return {
      postForm: Object.assign({}, defaultPostForm),
      schoolList: []
    }
  },
  watch: {
    'postForm.schoolId': function(val) {
      if (val) {
        var index = Tool.findIndexInArryByKeyVal(this.schoolList, 'id', val)
        if (index > -1) {
          this.postForm.schoolName = this.schoolList[index].schoolName
        }
        console.log(this.postForm)
      }
    }
  },
  created() {
    this.postForm.shop_id = this.shopId
    this.postForm.schoolId = this.schoolId
    this.getDeviceShopList()
  },
  methods: {
    getDeviceShopList() {
      this.$http.getScreenShopList().then(res => {
        (res.data || []).forEach(element => {
          element.id = element.schoolId
          element.name = element.schoolName
        })
        this.schoolList = res.data
      })
    },
    createData() {
      if (!this.postForm.schoolId) {
        this.$message({
          type: 'info',
          message: '请选择校区'
        })
        return
      }
      console.log(this.postForm)
      this.$http.bindingShopScreen(this.postForm).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '绑定成功'
          })
          this.$emit('successCBK')
        }
      })
    }

  }
}
</script>

<style scoped>
  .dialog-footer{
    text-align: right;
  }
</style>
